import React, { createContext, useContext, useState } from 'react'
import { User } from '@/types/user'

interface UserContextType {
  selectedUser: User | null
  setSelectedUser: (user: User | null) => void
  clearSelectedUser: () => void
}

const UserContext = createContext<UserContextType | undefined>(undefined)

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedUser, setSelectedUser] = useState<User | null>(null)

  const clearSelectedUser = () => {
    setSelectedUser(null)
  }

  return (
    <UserContext.Provider value={{ selectedUser, setSelectedUser, clearSelectedUser }}>
      {children}
    </UserContext.Provider>
  )
}

export const useUserContext = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider')
  }
  return context
}
